import {Box, Chip, Grid, Paper, Typography} from "@mui/material";
import {translate} from "../../../translate/translate";
import * as React from "react";
import BackButton from "../../../components/button/back-button.component";
import {useParams} from "react-router-dom";
import {PoMonitoring} from "../../../models/basic/po-monitoring";
import {useEffect} from "react";
import PoMonitoringStatusComponent from "./po-monitoring-status.component";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import {CompareArrows, PaidOutlined} from "@mui/icons-material";
import {formatDate} from "../../../utils/format-date";
import {formatNumber} from "../../../utils/format-number";
import TablePaginationComponent from "../../../components/table/table-pagination.component";
import TableActionComponent from "../../../components/table/table-action.component";
import {Material} from "../../../models/basic/material";
import CollapsibleTableComponent from "../../../components/table/collapsible-table.component";
import {sortListObj} from "../../../utils/list-utils";
import {PoMonitoringFilter, PoMonitoringService} from "../../../services/po-monitoring-service";
import {useFilters} from "../../../filters/base-filter";
import {orderByFn} from "../../../utils/order-by";
import {CustomTabPanel} from "../../../utils/custom-tab-panel";

const PoMonitoringDetailComponent = () => {
    const params = useParams();
    const id = params.id;
    const [tab, setTab] = React.useState(0);

    const servicePO = new PoMonitoringService();
    const expand = ["*"];
    const {filters, updateFilter, updateFilterKeepingParam, resetFilters } = useFilters<PoMonitoringFilter>(
        {ordering: ""},
        ["ordering"]
    );

    const [dataSourcePo, setDataSourcePo] = React.useState<PoMonitoring>(new PoMonitoring());
    const [dataSourceMaterial, setDataSourceMaterial] = React.useState<Material[]>([]);

    const [orderDirection, setOrderDirection] = React.useState<'asc' | 'desc' | ''>('asc');
    const [loading, setLoading] = React.useState(false);

    useEffect(() => {
        search();
        searchMaterial();
    }, []);

    const search = () => {
        if (id) {
            servicePO.readById(parseInt(id), {}, expand).then((response) => {
                setDataSourcePo(response.data);
            });
        }
    }

    const searchMaterial = () => {
        if (id) {
            setLoading(true);
            servicePO.getMaterials(parseInt(id), filters, expand).then((response) => {
                setDataSourceMaterial(response.data);
            }).finally(() => {
                setLoading(false);
            });
        }
    }

    useEffect(() => {
        searchMaterial();
    }, [filters.ordering]);

    const handleChangeTab = (event: React.SyntheticEvent, newValue: number) => {
        resetFilters();
        setTab(newValue);
    };

    const isError = (row: Material) => {
        return row.is_cancelled
    }

    const layoutDetailShipment = (row: Material) => {

        return (
            <TablePaginationComponent
                id={`table-pagination-shipment-${row.id}`}
                key={row.id}
                state={sortListObj(row.shipments, "expenses", )}
                displayedColumnsShow={["Expenses", "Accomplished value C"]}
                displayedColumns={["expenses", "accomplished_value_c"]}
                numberColumns={["accomplished_value_c"]}
                actionsComponent={TableActionComponent}
                secondaryLayout={true}
            />
        )
    }

    return <section style={{maxWidth: "calc(98vw - 150px)"}}>
        <div className="floating-title"style={{display: "flex", flexDirection: "row", alignItems: "center"}}>
            <BackButton url={'/purchase_order/purchase_order'} />
            <Typography variant={"h5"}>
                {translate.t("po_details")}: {dataSourcePo.number}
            </Typography>
        </div>
        <div>
            <Grid container spacing={3} bgcolor="white" margin="1rem auto" width="98%" maxWidth="calc(100% - 50px)" p={2}>
                <Grid size={4} container gap={1}>
                    <Grid size={12} display="flex" mb="5px" alignItems="center">
                        <Typography variant={"h6"} width="150px">PR:</Typography>
                        <Typography variant={"body1"}>{dataSourcePo.purchase_request ?? '---'}</Typography>
                    </Grid>
                    <Grid size={12} display="flex" mb="5px" alignItems="center">
                        <Typography variant={"h6"} width="150px">PO:</Typography>
                        <Typography variant={"body1"}>{dataSourcePo.number}</Typography>
                    </Grid>
                    <Grid size={12} display="flex" mb="5px" alignItems="center">
                        <Typography variant={"h6"} width="150px">PO Date:</Typography>
                        <Typography variant={"body1"}>{formatDate(dataSourcePo.purchase_date)}</Typography>
                    </Grid>
                    <Grid size={12} display="flex" mb="5px" alignItems="center">
                        <Typography variant={"h6"} width="150px">Category:</Typography>
                        <Typography variant={"body1"}>{dataSourcePo.category?.name ?? '---'}</Typography>
                    </Grid>
                    <Grid size={12} display="flex" alignItems="center">
                        <Typography variant={"h6"} width="150px">{translate.t("po_total")}:</Typography>
                        <Typography variant={"body1"} fontWeight="bold">{formatNumber(dataSourcePo.po_total?.toString(), true)}</Typography>
                    </Grid>
                </Grid>
                <Grid size={4} container gap={1}>
                    <Grid size={12} >
                        <Typography variant={"h6"}>Supplier/Vendor</Typography>
                        <Typography variant={"body1"}>{dataSourcePo.supplier?.name ?? '---'}</Typography>
                    </Grid>
                    <Grid size={12} mt="10px">
                        <Typography variant={"h6"}>Platform</Typography>
                        <Grid>
                            {dataSourcePo.projects? (dataSourcePo.projects?.map((project, index) => (
                                <Chip key={project.id} size="small" style={{ marginRight: '5px', marginBottom: '5px' }} label={project.project.name}/>
                            ))) : (
                                <Typography variant={"body1"}>---</Typography>
                            )}
                        </Grid>
                    </Grid>
                </Grid>
                <Grid size={4} container gap={1}>
                    <Grid size={12}>
                        <Typography variant={"h6"}>Origin:</Typography>
                        <Typography variant={"body1"}>{dataSourcePo.origin}</Typography>
                    </Grid>
                    <Grid size={12}  mt="10px">
                        <Typography variant={"h6"}>Status:</Typography>
                        <Typography variant={"body1"}>
                            <PoMonitoringStatusComponent obj={dataSourcePo} />
                        </Typography>
                    </Grid>
                </Grid>
            </Grid>
            <Box bgcolor="white" margin="1rem auto" width="98%" maxWidth="calc(100% - 50px)" pb={1}>
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <Tabs value={tab}
                          onChange={handleChangeTab}>
                        <Tab label={
                            <Grid display="flex" alignItems="center" gap="10px" color="secondary">
                                <PaidOutlined/>MATERIAL
                            </Grid>
                        } />
                        {dataSourcePo.origin.toString() === "Importada" && <Tab label={
                            <Grid display="flex" alignItems="center" gap="10px" color="secondary">
                                <CompareArrows/>SHIPMENT
                            </Grid>
                        }/>}
                    </Tabs>
                </Box>
                <CustomTabPanel value={tab} index={0}>
                    <Paper variant="outlined" sx={{marginTop: "16px"}}>
                        <TablePaginationComponent
                            state={dataSourceMaterial}
                            displayedColumnsShow={["Material", "Description", "Qty", "GR", "Net Price", "Net Value", "Currency", "Gross Value", "Plant", "NBM Code", "Shipment", "Unit Net", "Total Net", "Taxes", "Ext Value"]}
                            displayedColumns={["material_number", "material_description", "quantity", "gr", "net_price", "net_value", "currency", "gross_value", "plant", "nbm_code", "shipment", "unit_net_price", "total_net", "taxes", "ext_value"]}
                            fixedColumns={["material_number", "material_description"]}
                            numberColumns={["net_price", "net_value", "gross_value", "unit_net_price", "total_net", "taxes", "ext_value"]}
                            orderByColumns={["material_number", "material_description", "net_price", "net_value"]}
                            orderBy={filters.ordering}
                            orderByFn={(column: string, orderDirection: any) => {
                                orderByFn(column, orderDirection, filters.ordering || "", setOrderDirection, updateFilterKeepingParam);
                            }}
                            orderDirection={orderDirection}
                            actionsComponent={TableActionComponent}
                            columnStyles={{1:"100px", 2:"250px", 3:"150px", 4:"150px", 5:"150px", 6:"150px", 7:"150px", 8:"150px", 9:"150px", 10:"150px", 11:"150px", 12:"150px", 13:"150px", 14:"150px", 15:"150px"}}
                            errorRow={isError}
                            loading={loading}
                        />
                    </Paper>
                </CustomTabPanel>
                <CustomTabPanel value={tab} index={1}>
                    <Paper variant="outlined" sx={{marginTop: "16px"}}>
                        <CollapsibleTableComponent
                            state={dataSourceMaterial}
                            displayedColumnsShow={["Shipment", "Material", "Description"]}
                            displayedColumns={["shipment", "material_number", "material_description"]}
                            orderByColumns={["material_description"]}
                            orderBy={filters.ordering}
                            orderByFn={(column: string, orderDirection: any) => {
                                orderByFn(column, orderDirection, filters.ordering || "", setOrderDirection, updateFilterKeepingParam);
                            }}
                            orderDirection={orderDirection}
                            actionsComponent={TableActionComponent}
                            childrenComponent={layoutDetailShipment}
                            loading={loading}
                        />
                    </Paper>
                </CustomTabPanel>
            </Box>
        </div>
    </section>
}

// @ts-ignore
export default PoMonitoringDetailComponent;
